import styled from 'styled-components';

/**
 * Dashboard chart cards (pie / area). Kept in a small module so `Dashboard.jsx` imports
 * resolve reliably; mirrors `ContentCard` + chart layout (see tenant style.js).
 */
export const ChartCard = styled.div`
    padding: ${({ $padding }) => $padding || '16px'};
    border-radius: 12px;
    background: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#1f1f1f' : '#fff')};
    border: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? '#2C2C2C' : '#eee')};
    margin-bottom: ${({ $marginBottom }) => $marginBottom ?? '12px'};
    overflow: hidden;
    &:last-child {
        margin-bottom: 0;
    }
    min-height: 260px;
    display: flex;
    flex-direction: column;
`;

export const ChartCardTitle = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? '#fff' : '#1a1a1a')};
    margin: 0;
    font-family: var(--font-family-geist);
    letter-spacing: -0.01em;
    line-height: 1.3;
`;

export const ChartCardSubtitle = styled.div`
    font-size: 12px;
    color: ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.5)' : '#8c8c8c')};
    margin: 4px 0 0 0;
    font-family: var(--font-family-geist);
    line-height: 1.4;
`;

export const ChartCardHeader = styled.div`
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => (theme.colors.background.default === '#141414' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)')};
`;

export const ChartCardBody = styled.div`
    flex: 1;
    min-height: 200px;
    width: 100%;
    min-width: 0;
`;
